export const UPLOADED_FILES_TABLE_SECTION_I18N_PREFIX = "features.topics.components.uploaded_files_table_section";

export const UPLOADED_FILES_TABLE_SECTION_I18N_KEYS = {
  title:                         "title",
  file_name:                     "file_name",
  file_size:                     "file_size",
  file_language:                 "file_language",
  file_date_uploaded:            "file_date_uploaded",
  file_status:                   "file_status",
  kb_label:                      "kb_label"
};


// WEBPACK FOOTER //
// ./src/features/topics/components/constants/i18n/UploadedFilesTableSectioni18nConstants.js